import { render, staticRenderFns } from "./DatasetRowTaskmanager.vue?vue&type=template&id=789ed34f&"
import script from "./DatasetRowTaskmanager.vue?vue&type=script&lang=js&"
export * from "./DatasetRowTaskmanager.vue?vue&type=script&lang=js&"
import style0 from "./DatasetRowTaskmanager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports